import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-519199bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bt-mask-layer" }
const _hoisted_2 = { class: "navigation-frame" }
const _hoisted_3 = { class: "path-frame" }
const _hoisted_4 = {
  key: 0,
  class: "qh-icon-more"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 新建链接任务 ")
const _hoisted_6 = { class: "file-frame" }
const _hoisted_7 = {
  key: 0,
  class: "file-frame__ul"
}
const _hoisted_8 = { class: "file-frame__options" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "下载链接")
], -1))
const _hoisted_10 = ["checked"]
const _hoisted_11 = { class: "file-frame__options only-video" }
const _hoisted_12 = ["checked"]
const _hoisted_13 = { class: "submit-frame" }
const _hoisted_14 = { class: "file-upload__select" }
const _hoisted_15 = ["disabled"]

import { reactive, onMounted } from 'vue'
import { IconClose } from '@xunlei/thunder-icon-vue'
import FileInfo from '@remote/components/LinkInfo.vue'
import VirtualList from '@remote/components/VirtualList.vue'
import { isLargeViewPort as checkIsLargeViewPort } from '@remote/utils/base'
import { usePathSelector } from '@remote/store/hezi-file/path-selector'
import DownloadPath from './DownloadPath.vue'
import { LinkIcon } from '@remote/utils/file-helper'
import ElPopover from 'element-plus/es/components/popover'
import { store } from '@remote/store'


export default /*#__PURE__*/_defineComponent({
  props: {
    urls: null
  },
  emits: ['on-close', 'on-ok', 'on-floatup'],
  setup(__props: any, { emit }) {

const props = __props as { urls: string[] }


const { checkFileExit, selectedPath } = usePathSelector()

const data = reactive<{
  links: Array<{ checkType: boolean; url: string; icon: string }>
  chooseAll: boolean
  onlyVideo: boolean
  chooseIds: string[]
  isLargeViewPort: boolean
  visibleOnlyVideoTips: boolean
}>({
  links: props.urls.map(url => ({
    url, checkType: true, icon: LinkIcon,
  })),
  chooseAll: true, // 是否全选
  onlyVideo: true,
  chooseIds: props.urls.slice(),
  isLargeViewPort: checkIsLargeViewPort(),
  visibleOnlyVideoTips: false,
})



const handleClose = () => {
  emit('on-close')
}

const handleSubmit = () => {
  store.dispatch('getResource', {
    urls: data.chooseIds.join('\n'),
    downloadPath: selectedPath.value.path,
    onlyVideo: data.onlyVideo,
  })
  handleClose()
}

const handleChooseAll = () => {
  data.chooseAll = !data.chooseAll
  data.chooseIds = []

  data.links.forEach(link => {
    link.checkType = data.chooseAll
    if (data.chooseAll) {
      data.chooseIds.push(link.url)
    }
  })
}

const handleOnClickItem = (index: number) => {
  const link = data.links[index]
  link.checkType = !link.checkType
  if (link.checkType) {
    data.chooseIds.push(link.url)
  } else {
    const index = data.chooseIds.findIndex(id => id === link.url)
    data.chooseIds.splice(index, 1)
  }
  data.chooseAll = data.chooseIds.length === data.links.length
}

onMounted(checkFileExit)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "footer-frame",
      onClick: _cache[3] || (_cache[3] = _withModifiers(() => null, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_unref(data).isLargeViewPort)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
            : _createCommentVNode("", true),
          _hoisted_5
        ]),
        (_unref(data).isLargeViewPort)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "icomoon-close close-frame",
              onClick: handleClose
            }))
          : (_openBlock(), _createBlock(_unref(IconClose), {
              key: 1,
              width: "20",
              height: "20",
              href: "javascript:;",
              class: "close-frame",
              onClick: handleClose
            }))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_unref(data).links.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", null, [
                  _createElementVNode("i", {
                    class: "checkbox",
                    checked: _unref(data).chooseAll,
                    onClick: handleChooseAll
                  }, null, 8, _hoisted_10),
                  _createElementVNode("span", { onClick: handleChooseAll }, "全选")
                ])
              ]),
              (!!_unref(data).links.length)
                ? (_openBlock(), _createBlock(VirtualList, {
                    key: 0,
                    ref: "virtualList",
                    data: _unref(data).links,
                    "item-size": _unref(data).isLargeViewPort ? 36 : 60
                  }, {
                    default: _withCtx(({ item, index }) => [
                      (_openBlock(), _createBlock(FileInfo, {
                        key: item.url,
                        file: item,
                        index: index,
                        onUpdate: handleOnClickItem
                      }, null, 8, ["file", "index"]))
                    ]),
                    _: 1
                  }, 8, ["data", "item-size"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _createElementVNode("i", {
                    class: "checkbox",
                    checked: _unref(data).onlyVideo,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(data).onlyVideo = !_unref(data).onlyVideo))
                  }, null, 8, _hoisted_12),
                  _createElementVNode("span", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(data).onlyVideo = !_unref(data).onlyVideo))
                  }, "仅下载视频"),
                  _createVNode(_unref(ElPopover), {
                    placement: "top",
                    title: "",
                    width: 200,
                    "popper-style": { fontSize: '13px' },
                    effect: "dark",
                    content: "链接中的非视频文件，可能会导致任务无法完成下载",
                    trigger: "hover"
                  }, {
                    reference: _withCtx(() => [
                      _createElementVNode("i", {
                        class: "icomoon-question",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(data).visibleOnlyVideoTips = !_unref(data).visibleOnlyVideoTips))
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(DownloadPath, { class: "bt-choice-pop-download-path" })
        ]),
        _createElementVNode("div", {
          class: "submit-btn",
          onClick: handleSubmit,
          disabled: !_unref(data).chooseIds.length
        }, " 立即下载 ", 8, _hoisted_15)
      ])
    ])
  ]))
}
}

})